/*layout.js*/
export const LAYOUT_MINI = 'LAYOUT_MINI'
export const LAYOUT_DRAWER = 'LAYOUT_DRAWER'

/*auth.js*/
export const LOGOUT = 'LOGOUT'
export const SET_LOGIN = 'SET_LOGIN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const FETCH_ABILITIES = 'FETCH_ABILITIES'

/*page.js*/
export const PAGE_NAME = 'PAGE_NAME'

/*permission*/
export const PERMISSIONS = 'PERMISSIONS'
export const PERMISSION_SEARCH = 'PERMISSION_SEARCH'
export const PERMISSION_PAGE = 'PERMISSION_PAGE'
export const PERMISSION_CURRENTPAGE = 'PERMISSION_CURRENTPAGE'
export const PERMISSION_LOADING = 'PERMISSION_LOADING'
export const PERMISSION_CREATE = 'PERMISSION_CREATE'
export const PERMISSION_STORE = 'PERMISSION_STORE'
export const PERMISSION_EDIT = 'PERMISSION_EDIT'
export const PERMISSION_UPDATE = 'PERMISSION_UPDATE'
export const PERMISSION_CLEAR = 'PERMISSION_CLEAR'
export const PERMISSION_ID = 'PERMISSION_ID'
export const PERMISSION_ERROR = 'PERMISSION_ERROR'
export const ALL_PERMISSIONS = 'ALL_PERMISSIONS'

/*role*/
export const ROLES = 'ROLES'
export const ROLE_SEARCH = 'ROLE_SEARCH'
export const ROLE_PAGE = 'ROLE_PAGE'
export const ROLE_CURRENTPAGE = 'ROLE_CURRENTPAGE'
export const ROLE_LOADING = 'ROLE_LOADING'
export const ROLE_CREATE = 'ROLE_CREATE'
export const ROLE_STORE = 'ROLE_STORE'
export const ROLE_EDIT = 'ROLE_EDIT'
export const ROLE_UPDATE = 'ROLE_UPDATE'
export const ROLE_CLEAR = 'ROLE_CLEAR'
export const ROLE_ID = 'ROLE_ID'
export const ROLE_ERROR = 'ROLE_ERROR'
export const ALL_ROLES = 'ALL_ROLES'
export const ADD_PERMISSION = 'ADD_PERMISSION'

/*users*/
export const USERS = 'USERS'
export const USER_SEARCH = 'USER_SEARCH'
export const USER_PAGE = 'USER_PAGE'
export const USER_CURRENTPAGE = 'USER_CURRENTPAGE'
export const USER_LOADING = 'USER_LOADING'
export const USER_EDIT = 'USER_EDIT'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_CLEAR = 'USER_CLEAR'
export const USER_ID = 'USER_ID'
export const USER_ERROR = 'USER_ERROR'
export const USER_EENO = 'USER_EENO'
export const USER_EMAIL = 'USER_EMAIL'
export const USER_NAME = 'USER_NAME'
export const ADD_ROLE = 'ADD_ROLE'

/* activity logs */
export const ACTIVITY_LOGS = 'ACTIVITY_LOGS'
export const ACTIVITY_LOG_LOADING = 'ACTIVITY_LOG_LOADING'
export const ACTIVITY_LOG_PAGE = 'ACTIVITY_LOG_PAGE'
export const ACTIVITY_LOG_CURRENTPAGE = 'ACTIVITY_LOG_CURRENTPAGE'
export const ACTIVITY_LOG_SEARCH = 'ACTIVITY_LOG_SEARCH'
